<template>
  <BTable
    class="BTableCollectorParticipants"
    v-bind="$attrs"
    :selected="value"
    :headers="headers"
    :actions="actions"
    :list="list"
    v-on="$listeners || {}"
  >
    <template #item.count="{ header, item }">
      <span
        v-text="header.getValue(item)"
      />
    </template>

    <template #item.is_first_blank_generation="{ value: flag }">
      <v-tooltip top>
        <template #activator="{ attrs, on }">
          <v-icon
            v-bind="attrs"
            :color="flag ? 'success' : 'error'"
            v-on="on"
            v-text="flag ? 'mdi-checkbox-marked-outline' : 'mdi-close-circle-outline'"
          />
        </template>
        <span v-text="flag ? 'Бланк 1 генерируется' : 'Бланк 1 не генерируется'" />
      </v-tooltip>
    </template>

    <template #item.is_criteria_generation="{ value: flag }">
      <v-tooltip top>
        <template #activator="{ attrs, on }">
          <v-icon
            v-bind="attrs"
            :color="flag ? 'success' : 'error'"
            v-on="on"
            v-text="flag ? 'mdi-checkbox-marked-outline' : 'mdi-close-circle-outline'"
          />
        </template>
        <span v-text="flag ? 'Критерии генерируются' : 'Критерии не генерируются'" />
      </v-tooltip>
    </template>
  </BTable>
</template>

<script>
import {
  TABLE_HEADERS,
  TABLE_ACTIONS,
} from '@/views/CollectorPublications/Participants/table-headers'
import BTableSimple from './BTableSimple.vue'


export default {
  name: 'BTableCollectorParticipants',
  extends: BTableSimple,
  props: {
    value: Array,
    headers: {
      type: Array,
      default: () => TABLE_HEADERS,
    },
    actions: {
      type: Array,
      default: () => TABLE_ACTIONS,
    },
  },
}
</script>

